import { useEffect, useState } from "react";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

export function useGetSelectedPaymentMethodDetails() {
  const {
    state: { paymentMethods, selectedPaymentMethodID },
  } = usePaymentPage();

  const [paymentMethod, setPaymentMethod] = useState({});

  useEffect(() => {
    if (
      !selectedPaymentMethodID ||
      !paymentMethods ||
      paymentMethods.length === 0
    )
      return;

    const selectedMethod = paymentMethods.find(
      (p) => p.ID === selectedPaymentMethodID
    );

    if (selectedMethod) setPaymentMethod(selectedMethod);
  }, [paymentMethods, selectedPaymentMethodID]);

  return paymentMethod;
}
